export interface ScannerMenuItem {
  id: string;
  label: string;
  path: string;
  description: string;
  isDeveloperOnly?: boolean;
}

export const scannerMenuItems: ScannerMenuItem[] = [
  {
    id: "kwc-bags",
    label: "KWC Controle",
    path: "/kwc-bags",
    description: "Controle van zak en product",
  },
  {
    id: "kwc-bins",
    label: "KWC Bakken",
    path: "/kwc-bins",
    description: "Controle van bak en zak",
  },
  {
    id: "pick-list",
    label: "Pick List",
    path: "/pick-list",
    description: "Ready-to-send pick flow",
  },
  {
    id: "counter-checkout",
    label: "Balie checkout",
    path: "/counter-checkout",
    description: "Checkout aan de balie via scanner",
  },
  {
    id: "worktable",
    label: "Werktafels",
    path: "/worktable",
    description: "Zakken verwerken aan de werktafel",
  },
  {
    id: "qr-codes",
    label: "QR Codes Printen",
    path: "/qr-codes",
    description: "Printbare QR-codes per scannerknop",
    isDeveloperOnly: true,
  },
  {
    id: "kwc-bins-test",
    label: "kwc-bins-test",
    path: "/kwc-bins-test",
    description: "Developer testpagina voor bakken",
    isDeveloperOnly: true,
  },
  {
    id: "kwc-bags-test",
    label: "kwc-bags-test",
    path: "/kwc-bags-test",
    description: "Developer testpagina voor controle",
    isDeveloperOnly: true,
  },
];

export const scannerMenuItemsByPath = new Map(scannerMenuItems.map((item) => [item.path, item]));
export const scannerMenuItemsById = new Map(scannerMenuItems.map((item) => [item.id, item]));
